const $win = $(window);

// Slider Messages
const $sliderBlock = $('.js-slider-block');

$sliderBlock.each(function() {
  const $slider = $(this);

  $slider.find('.slider__slides').slick({
    lazyLoad: 'ondemand',
    infinite: true,
    autoplay: false,
    speed: 300,
    arrows: true,
    dots: true,
    slidesToShow: 1,
    appendDots: $slider,
    slidesToScroll: 1
  });
});

// Slider Messages
$('.js-slider-primary .slider__slides').slick({
  infinite: false,
  autoplay: false,
  speed: 300,
  arrows: true,
  dots: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  draggable: false,
  touchMove: false,
  swipe: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// Slider Swatches

$win.on('load-products', function() {
  $('.js-radios-slider').slick({
    infinite: false,
    autoplay: false,
    speed: 300,
    arrows: true,
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    draggable: false,
    swipe: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1
        }
      }
    ]
  });
});

// Slider Products
const $sliderProduct = $('.js-slider-products');

$sliderProduct.each(function() {
  const $slider = $(this);

  $slider.find('.slider__slides').slick({
    infinite: false,
    autoplay: false,
    speed: 300,
    arrows: true,
    dots: true,
    appendDots: $slider,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});

// Slider Slider Mobile
const sliderMobile = () => {
  const $sliderMobileItems = $('.js-slider-mobile');

  if ($win.width() < 768 && !$('.js-slider-mobile.slick-slider').length) {
    $sliderMobileItems.slick({
      infinite: true,
      autoplay: false,
      speed: 300,
      arrows: true,
      dots: true
    });
  } else if ($win.width() > 767 && $('.js-slider-mobile.slick-slider').length) {
    $sliderMobileItems.slick('unslick');
  }
};

$win.on('load resize', function() {
  // Slider Slider Mobile
  sliderMobile();
});



// WEBPACK FOOTER //
// ../assets/js/sliders.js